import { useCallback } from 'react';
import { useHistory } from 'react-router';

export const useGoalDetailPanel = () => {
  const history = useHistory();

  const handleOpenPanel = useCallback(slug => {
    let path = location.pathname;
    // need to check and see if the panel is already open - if so, we need
    // strip the existing uuid off the route before appending the new one
    if (path.includes('/goals/')) {
      path = path.split('/goals/')[0];
    }

    if (path.includes('/goals')) {
      path = path.split('/goals')[0];
    }

    // check for trailing slash
    path = path.slice(-1) === '/' ? path.slice(0, -1) : path;

    history.push({
      pathname: `${path}/goals/${slug}/detail`,
      //   state: { modal: location.state?.modal, preventPreviousRouteChange: location.state?.modal },
    });
  }, []);

  const handleClosePanel = () => {
    let path = location.pathname;

    if (path.includes('/goals')) {
      path = path.split('/goals')[0];
    }

    history.push(`${path}/goals`);
  };

  return {
    handleOpenPanel,
    handleClosePanel,
  };
};
